import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = () => {
    if (window.history.length > 2 && location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 4,
      }}
    >
      <Typography
        variant="h1"
        color={'primary'}
        sx={{ fontSize: '12rem !important' }}
      >
        404
      </Typography>
      <Typography variant="subtitle1">
        Oops! The page you are looking for does not exist.
      </Typography>
      <Button variant="outlined" onClick={handleNavigation} size="large">
        Take Me Back to Safety
      </Button>
    </Box>
  );
};

export default NotFoundPage;
